import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import services from '../services';
import { selectUser } from '../reducers/user.selectors';
import { addItemToCollection, deleteItemFromCollection } from '../actions/collections.actions';
import { ContentItem } from '../types/AppContent';
import { getAmpliContentEventPayload, getSearchIdWithFallback } from './ampli';
import {
  CollectionContentAdded,
  CollectionContentRemoved,
  CollectionContentRemovedProperties,
  CollectionContentAddedProperties
} from '../ampli';

const useCollectionActions = (collectionId: string) => {
  const dispatch = useDispatch();
  const user = useSelector(selectUser);

  const addItem = useCallback((item: ContentItem) => {
    dispatch(addItemToCollection(collectionId, item.type, item.id));
    if (user) {
      const eventProperties = getAmpliContentEventPayload(item, item.type,
        {
          collectionPreexistence: 'existing collection',
        }
      );

      const searchId = getSearchIdWithFallback();
      const payload: CollectionContentAddedProperties = {
        content: eventProperties.content as unknown as string[],
        'collection preexistence': 'existing collection',
        ...(searchId && { 'search id': searchId }),
      };

      services.track.ampliEventTrack({
        event: new CollectionContentAdded(payload)
      });
    }
  }, [dispatch, user, collectionId]);

  const removeItem = useCallback((item: ContentItem) => {
    dispatch(deleteItemFromCollection(collectionId, item.type, item.id));
    if (user) {
      const eventProperties = getAmpliContentEventPayload(item, item.type);
      const collectionContentRemovedPayload = {
        content: eventProperties.content,
      };
      services.track.ampliEventTrack({
        event: new CollectionContentRemoved(collectionContentRemovedPayload as CollectionContentRemovedProperties)
      });
    }
  }, [dispatch, user, collectionId]);

  return { addItem, removeItem };
};

export default useCollectionActions;
